import { RouteLocationNormalizedGeneric, RouteLocationNormalizedLoadedGeneric } from "vue-router";

export async function maintenanceGuard(to: RouteLocationNormalizedGeneric, from: RouteLocationNormalizedLoadedGeneric) {
  const isMaintenance = import.meta.env.VITE_MAINTENANCE_MODE === 'true';

  // If maintenance mode is enabled and the user is not on the maintenance page, redirect to maintenance page
  if (isMaintenance && to.path !== '/maintenance') {
    return { path: '/maintenance'};
  } else if (!isMaintenance && to.path === '/maintenance') { // If maintenance mode is disabled and the user is on the maintenance page, redirect to auth page
    return { name: 'auth' };
  }
  // Otherwise, proceed as normal
}